import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as _ from 'lodash-es';

@Injectable({
  providedIn: 'root'
})
export class ReqHeaderElementsService {

  constructor(private http: HttpClient) { }

  /**
   * Mirrors legacy `JsonObjectFactory.getJSONObj(base + '/loadJsonObject?action_code=yzgy3w', { submission_id })`.
   * Backend expects the merged context (globalParams ⊕ activeScreen filterParams ⊕ submission_id):
   *   action_code, activity_key, is_locked, issue_id, issue_short_desc, jcd_key, jcd_ta_key,
   *   scenario, screen_key, screen_type, submission_id, tax_year
   */
  getHeaderElements(
    baseUrl: string,
    submissionId: string,
    globalParams: any = {},
    filterParams: any = {}
  ): Observable<any> {
    const merged: any = _.merge({}, globalParams || {}, filterParams || {}, {
      submission_id: submissionId
    });
    delete merged.checkLockedbj;

    const urlEncoded = new URLSearchParams();
    Object.keys(merged).forEach((key) => {
      const value = merged[key];
      if (value === undefined || value === null) {
        return;
      }
      if (typeof value === 'object') {
        urlEncoded.set(key, JSON.stringify(value));
      } else {
        urlEncoded.set(key, String(value));
      }
    });

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    return this.http.post<any>(
      `${baseUrl}/loadJsonObject?action_code=yzgy3w`,
      urlEncoded.toString(),
      { headers, withCredentials: true }
    );
  }
}
